document.addEventListener('DOMContentLoaded', () => {

    const headerButtons = document.querySelector('.js-header-buttons');
    let scrolledFromTop = window.scrollY;

    window.addEventListener('scroll', () => {
        if (!headerButtons) {
            return false;
        }

        scrolledFromTop = window.scrollY;

        if (scrolledFromTop > 50) {
            headerButtons.classList.add('is-active');
        } else {
            headerButtons.classList.remove('is-active');
        }
    });


    const roomsList = document.querySelector('#rooms-list');

    if (roomsList) {
        addEventListener('scroll', () => {
            if (window.scrollY > roomsList.offsetTop) {
                document.body.classList.add('green-triggers');
            } else {
                document.body.classList.remove('green-triggers');
            }
        });
    }


});